import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppNames } from '@app/models/AppNames';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';

import { environment } from './../../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private readonly oidcSecurityService: OidcSecurityService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let bearerToken: string;
    const appName = sessionStorage.getItem('appName');
    // Check App - get token from localStorage if Express or get it from OIDC service if Direct.
    if (appName === AppNames.UNITY_EXPRESS) {
      bearerToken = localStorage.getItem('access_token');
    } else {
      bearerToken = this.oidcSecurityService.getAccessToken(appName);
    }

    if (
      environment.type === 'local' ||
      environment.type === 'dev' ||
      environment.type === 'qa' ||
      appName === AppNames.UNITY_DIRECT
    ) {
      req = req.clone({
        setHeaders: {
          Accept: 'application/json',
          Authorization: `Bearer ${bearerToken}`
        }
      });
    }
    return next.handle(req);
  }
}
